// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"51507c2d","278":"30e54a95","768":"2e68ccfd","781":"64e48b42","962":"8e8736ad"}[chunkId] + ".chunk.js";
};